import "../css/gallery.css";
import { useState, useEffect } from "react";

function ContentGallery({ gallery, id }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % gallery.length);
      const element = document.getElementById(`wrappergallery-${id}`);
      if (element) {
        element.scrollLeft =
          ((currentIndex + 1) % gallery.length) * element.offsetWidth;
      }
    }, 8000);

    return () => clearInterval(interval);
  }, [gallery.length, id, currentIndex]);

  const handleIndicatorClick = (index) => {
    const element = document.getElementById(`wrappergallery-${id}`);
    if (!element) return;
    element.scrollLeft = index * element.offsetWidth;
    setCurrentIndex(index);
  };

  return (
    <>
      <div className="wrapper-gallery">
        <div id={`wrappergallery-${id}`} className="gallery-container">
          {gallery.map((content, index) => (
            <div className="item-gallery " key={index}>
              <div
              className="flex-center col2 layout8" 
              dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          ))}
        </div>
      </div>

      <div className="gallery-indicators">
        {gallery.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => handleIndicatorClick(index)}
          >
            ●
          </span>
        ))}
      </div>
    </>
  );
}

export default ContentGallery;
